import { _ep0, _mw0, command } from "../commandBuilder";
import { DeleteCurrentUser$ } from "../schemas/schemas_0";
export class DeleteCurrentUserCommand extends command(_ep0, _mw0, "DeleteCurrentUser", DeleteCurrentUser$) {
}
